export default __webpack_public_path__ + "static/media/Arm Bands of the Masquer of the Sands.0399924b.jpg";